export const about = {
  hero: {
    title: '当科学遇见烟火气',
    subtitle: '膳兜兜的品牌起源',
    description: '在快节奏的都市丛林中，我们常常陷入一种两难：渴望健康的身体，却不得不向便利与口味妥协；想要传统的食疗养生，却畏惧繁琐的熬煮与苦涩的口感。膳兜兜的诞生，正是为了解决这道现代生活的"饮食悖论"。',
  },
  origin: {
    title: '品牌起源',
    story: '我们的故事，始于一间并不起眼，却充满魔力的食品实验室。一群"较真"的研发者，在古老的东方食疗智慧与现代食品科学之间，寻找着奇妙的化学反应。',
  },
  philosophy: {
    title: '核心理念',
    subtitle: '数据里的东方智慧',
    points: [
      { title: '数据驱动研发', description: '每一款产品的背后，都是无数次的数据测试与感官打磨。我们用科学方法验证传统智慧。' },
      { title: '清洁标签承诺', description: '拒绝化学添加剂的过度修饰。最好的配方师是大自然，实验室的使命是剔除杂质，留下精华。' },
      { title: '全球寻源', description: '深入全球优质原产地，寻找最纯净的绿色食材，从源头把控品质。' },
      { title: '药食同源', description: '让养生不再是一碗苦药，而是一次愉悦的味蕾旅行。健康，也可以是甜的。' },
    ],
  },
  vision: {
    title: '品牌愿景',
    subtitle: '重新定义"轻养生"',
    text: '膳兜兜不仅是一个食品品牌，更是一种生活方式的提案者。我们致力于打破传统滋补的厚重感，用实验室的严谨标准，做最懂年轻人的轻养生食品。我们希望，当你感到疲惫时，从兜里掏出的不仅仅是一份零食，而是一份经过科学配比的健康方案；是一份能瞬间唤醒身体机能的自然能量。',
  },
  nameMeaning: {
    title: '品牌释义',
    subtitle: '兜住健康，即刻出发',
    chars: [
      { char: '膳', explain: '美好的食物，也是对身体最温柔的滋养' },
      { char: '兜兜', explain: '温暖的容器，将繁杂的营养浓缩于方寸之间，让你能轻松"兜"着走' },
    ],
    english: 'foodgogo',
    englishMeaning: '传递鲜活的态度。健康不应是静止的守候，而是动态的随行。',
  },
  timeline: {
    title: '品牌里程碑',
    events: [
      { year: '2023', event: '膳兜兜实验室成立，组建核心研发团队' },
      { year: '2024', event: '第一款功能性软糖上市，获得年轻消费者好评' },
      { year: '2024', event: '冻干滋补品系列发布，FD技术获行业认可' },
      { year: '2025', event: '中式草本能量棒上线，完成三大产品赛道布局' },
      { year: '2026', event: '品牌全面升级，开启轻养生生活方式提案' },
    ],
  },
};